module.exports = __webpack_public_path__ + "static/img/1-1.4869562.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/1-1.png
// module id = zHpW
// module chunks = 0